import Button from "react-bootstrap/Button";
import {
  VerifiedTooltip,
  VerifiedTooltipLinkDark,
} from "../CustomCheckTooltips/CustomCheckTooltips";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { subscribersFetcher } from "../../../api/requests";
import { baseURL } from "../../../api/dataFetcher";

export default function SubscriptionChannelCard({
  views,
  channelName,
  subscriberCount,
  verified,
  channelId,
  subscriptionId,
  initialSubscribed,
  setRefresh,
  refresh,
  imgSrc,
}) {
  const [subscribed, setSubscribed] = useState(initialSubscribed);

  const showVerifyBadge = subscribed ? (
    <VerifiedTooltip />
  ) : (
    <VerifiedTooltipLinkDark />
  );
  const buttonVariant = subscribed ? "info" : "secondary";
  const buttonText = subscribed ? "عضو هستید" : "عضو شوید";

  const handleSubscribeClick = async () => {
    setSubscribed(!subscribed);

    if (subscribed) {
      try {
        const res = await subscribersFetcher.unsubscribe(subscriptionId);
      } catch (error) {
        console.error("Error unsubscribing:", error);
      }
    } else {
      try {
        const res = await subscribersFetcher.subscribe(channelId);

        setRefresh(!refresh);
      } catch (error) {
        console.error("Error subscribing:", error);
      }
    }
  };

  return (
    <>
      <div className="channels-card">
        <div className="channels-card-image">
          <a href={`/single-channel/${channelId}`}>
            <img
              className="img-fluid"
              style={{ objectFit: "cover" }}
              src={imgSrc ? baseURL + imgSrc : "/img/s1.png"}
              alt=""
            />
          </a>
          <div className="channels-card-image-btn">
            <Button
              variant={buttonVariant}
              size="sm"
              className="border-none"
              onClick={handleSubscribeClick}
            >
              {buttonText} <strong>{views}</strong>
            </Button>
          </div>
        </div>
        <div className="channels-card-body">
          <div className="channels-title">
            <a href={`/single-channel/${channelId}`}>
              {channelName} {verified ? showVerifyBadge : ""}
            </a>
          </div>
          <div className="channels-view">{subscriberCount} عضو</div>
        </div>
      </div>
    </>
  );
}
